module.exports = __webpack_public_path__ + "static/media/message-sending.b8cb0adc.svg";